import { defineComponent, onMounted } from 'vue';
export default defineComponent({
  name: 'HomeView',
  components: {},
  computed: {},
  setup() {
    onMounted(() => {});
    return {};
  }
});